<ng-content select="mc-tree-node-toggle"></ng-content>

<mc-pseudo-checkbox
    *ngIf="showCheckbox"
    [state]="selected ? 'checked' : 'unchecked'"
    [disabled]="disabled">
</mc-pseudo-checkbox>

<ng-content select="mc-checkbox"></ng-content>

<ng-content select="[mc-icon]"></ng-content>

<ng-content select="mc-progress-spinner"></ng-content>

<span class="mc-option-text mc-no-select"><ng-content></ng-content></span>

<ng-content select="mc-option-action"></ng-content>

<div class="mc-option-overlay"></div>
